import { createSelector } from 'reselect';
import { getSportNames } from './../lib/sportUtils';

export const centers = state => state.centers;
export const playgrounds = state => state.playgrounds;
export const sports = state => state.sports;
export const bookings = state => state.bookings;
export const bookingsTypes = state => state.bookingTypes;
export const users = state => state.users;
function centerId(c) {
  if (!c) return null;
  return c.id != null ? c.id : c.Id;
}

function centerName(c) {
  if (!c) return '';
  return c.name || c.Name || '';
}

function matchCenter(centersList, playground) {
  const complexId = playground.complexId != null
    ? playground.complexId
    : (playground.complex_id != null
      ? playground.complex_id
      : (playground.centerId != null ? playground.centerId : playground.center_id));
  return (centersList || []).find(c => String(centerId(c)) === String(complexId));
}

export const listPLaygrounds = createSelector(
  [centers, playgrounds, sports],
  (centers, playgrounds, sports) => {
    return (playgrounds || []).map((i) => {
      // Лёгкий ответ API (PlaygroundListResult) уже содержит centerName и city
      const linked = matchCenter(centers, i);
      const centerTitle = i.centerName || i.CenterName || centerName(linked);
      const city = i.city || i.City || (linked ? (linked.city || linked.City || '') : '');
      return {
        id: i.id != null ? i.id : i.Id,
        name: i.name || i.Name,
        center: centerTitle,
        city,
        sport: getSportNames(i.sport),
        price: i.price,
      };
    });
  }
);

export const listBookings = createSelector([bookings, playgrounds, centers, bookingsTypes, users],
  (bookings, playgrounds, centers, types, users) => {
    // Проверяем, что types является массивом или объектом
    const typesArray = Array.isArray(types) ? types : [];
    const typesObject = types && typeof types === 'object' && !Array.isArray(types) ? types : {};
    
    return bookings.map((booking) => {
      const playground = playgrounds.find(p => p.id === booking.playgroundId) || { name: 'Площадка удалена' };
      // Пробуем разные варианты получения центра - через booking.centerId или через playground.complexId
      const center = matchCenter(centers, {
        complexId: booking.centerId != null ? booking.centerId : booking.center_id,
      }) || matchCenter(centers, playground) || { name: 'Центр удален' };
      const user = users.find(u => (u.id != null ? u.id : u.Id) === booking.userId) || { name: 'Пользователь удален' };
      
      // Если bookingTypes - объект (словарь статусов), используем booking.state как ключ
      // Если bookingTypes - массив, пытаемся найти по typeId
      let stateName = booking.state;
      if (booking.typeId && typesArray.length > 0) {
        const type = typesArray.find(t => t.id === booking.typeId);
        stateName = type ? type.name : booking.state;
      } else if (booking.state && typesObject[booking.state]) {
        stateName = typesObject[booking.state];
      }

      return {
        id: booking.id,
        date: booking.date,
        user: user.name,
        phone: user.phone,
        price: booking.price,
        center: center.name,
        playground: playground.name,
        state: stateName,
        intervals: booking.intervals,
      };
    });
  }
);
